module.exports = __webpack_public_path__ + "img/home.79ca52a5.png";